/**
 * Derive live stream status directly from hub streaming settings.
 * No network call needed — the hub response already contains this data.
 * Extracted from DropPage against the 400-line ceiling.
 */
import type { StreamingSettings } from "@/hooks/hub/useGetHub";

export function getLiveStreamStatus(streamingSettings?: StreamingSettings): { hasLive: boolean; liveCount: number } {
    if (!streamingSettings?.enabled || !streamingSettings?.featuredStreams?.length) {
        return { hasLive: false, liveCount: 0 };
    }
    const liveStreams = streamingSettings.featuredStreams.filter(s => s.isLive);
    return { hasLive: liveStreams.length > 0, liveCount: liveStreams.length };
}
